/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_DescriptionInputs */

const es_admin_billing_description = /** @type {(inputs: Admin_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de facturas y recargas de mensajes.`)
};

const en_admin_billing_description = /** @type {(inputs: Admin_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice history and message top-ups.`)
};

/**
* | output |
* | --- |
* | "Invoice history and message top-ups." |
*
* @param {Admin_Billing_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_description = /** @type {((inputs?: Admin_Billing_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_description(inputs)
	return en_admin_billing_description(inputs)
});
export { admin_billing_description as "admin.billing.description" }